import React from 'react';
import {
  isImageFile,
  isMarkdownFile,
  readMarkdownFiles
} from '../../Lib/markdownFiles.js';

export default ({
  onMarkdownLoaded = () => {},
  ...props
}) => {
  const onChange = e => {
    const files = Array.from(e.currentTarget.files || []);
    if (files.some(isMarkdownFile)) {
      readMarkdownFiles(files, onMarkdownLoaded, error => alert(error.message));
    } else if (files.some(isImageFile)) {
      onMarkdownLoaded(null, null, files.filter(isImageFile));
    } else {
      alert('Choose a Markdown file or an image.');
    }
    e.currentTarget.value = '';
  };
  return (
    <p {...props} style={{ position: 'relative' }}>
      <input
        id="mdFile"
        type="file"
        style={{ display: 'none' }}
        onChange={onChange}
        accept=".md,image/*"
        multiple
      />
      <label
        htmlFor="mdFile"
        style={{
          position: 'absolute',
          opacity: 0,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2,
          cursor: 'pointer'
        }}
      />
      <span role="img" aria-label="upload">
        📁
      </span>
      <span>Choose files</span>
    </p>
  );
};
